module.exports = __webpack_public_path__ + "assets/place-min-grey-2.96d08cd91ad3507c37ae5247a88aa5b1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/place-min-grey-2.png
 ** module id = 190
 ** module chunks = 0
 **/